<web-design-system-modal (dismiss)="modal.close()">
  <div [innerHTML]="'depot.direct-debit-hint.text' | transloco"></div>
  <div class="d-flex justify-content-end mt-4">
    <web-design-system-button size="small" type="primary" (click)="activateDirectDebit()">
      {{ 'depot.direct-debit-hint.btn' | transloco }}
    </web-design-system-button>
  </div>
</web-design-system-modal>
